import React, { useEffect } from "react";


import privacyPolicyBannerImg from '../../utils/assets/shared/bgImg.png';
import WelcomeSection from "../../shared/components/WelcomeSection/WelcomeSection";
import NavegationInfo from "../../shared/components/NavegationInfo/NavegationInfo";
import PrivacyTerms from "../components/PrivacyTerms/PrivacyTerms";


const PrivacyPolicy = props => {
    
    const bannerSectionInfo =
     {
        cardTitle: "How we use and collect your information",
        cardBodyText: ``,
        cardButtonText: "Call Us",
        lengendBackground: privacyPolicyBannerImg
     }
     useEffect(()=>{
        window.scroll(0,0);
     })

    return (
        <React.Fragment>
        <WelcomeSection props={bannerSectionInfo}/>
        <NavegationInfo page="Privacy policy"/>
        <PrivacyTerms/>

        </React.Fragment>
    );
};

export default PrivacyPolicy;